import React, { useState } from 'react';
import classNames from 'classnames';
import PopOver from '../pop-over/pop-over';
import { TooltipPlacement } from 'antd/lib/tooltip';
import './color-picker.scss';
import Button from '../button/button';

interface Props {
	colors: string[];
	placement?: TooltipPlacement;
	selectedIndex?: number;
	onSelect?: (color: string) => void;
	getPopupContainer?: () => HTMLElement;
	className?: string;
}

const ColorPicker = (props: Props) => {
	const { colors, placement = 'bottomLeft', selectedIndex = -1, onSelect, getPopupContainer, className } = props;
	const [visible, setVisible] = useState<boolean>(false);

	const colorClick = (color: string) => {
		onSelect && onSelect(color);
		setVisible(false);
	};

	const content = () => (
		<div className="colors-list">
			{colors.map((color, i) => (
				<span
					key={`${color}_${i}`}
					className={`color-item ${selectedIndex === i ? 'selected' : ''}`}
					style={{ backgroundColor: color }}
					onClick={e => {
						e.stopPropagation();
						colorClick(color);
					}}
				></span>
			))}
		</div>
	);

	return (
		<PopOver
			overlayClassName="bringg-color-picker"
			content={content}
			placement={placement}
			trigger="click"
			open={visible}
			onOpenChange={setVisible}
			getPopupContainer={() => getPopupContainer?.() || document.body}
		>
			<Button
				className={classNames('color-picker-button', className)}
				style={{ backgroundColor: colors[selectedIndex] }}
				data-test-id="color-picker-button"
				onClick={e => {
					e.stopPropagation();
				}}
			>
				{' '}
			</Button>
		</PopOver>
	);
};

export default ColorPicker;
